<template>
  <div id="app" v-if="this.$route.meta.auth !== undefined">
    <nav-component v-if="isLoggedIn && $route.name !== 'reportPrint'"></nav-component>
    <main class="main">
      <header-component v-if="isLoggedIn && $route.name !== 'reportPrint'"></header-component>
      <div class="container">
        <router-view/>
      </div>
    </main>
    <notifications></notifications>
    <div class="loading" v-if="loading">
      <img src="/static/icons/pack1/loading.svg" alt="Espere un momento por favor" class="loading__image">
    </div>
  </div>
</template>

<script>
import notifications from '@/components/layout/notifications'
import navComponent from '@/components/nav'
import headerComponent from '@/components/header'
import {auth} from '@/core/libs/sessions'
import {storageLocal} from '@/core/libs/storage'
import httpService from '@/core/api/request'
export default {
  name: 'App',
  mixins: [httpService],
  components: {
    notifications,
    navComponent,
    headerComponent
  },
  created: function () {
    if (this.$route.meta.auth !== undefined) {
      this.validateLogin()
    }
  },
  watch: {
    '$route.meta.auth': function () {
      if (this.$route.meta.auth !== undefined) {
        this.validateLogin()
      }
    }
  },
  methods: {
    validateLogin: function () {
      auth.loggedIn(this.$route)
        .then(
          response => {
            if (response.auth) {
              this.setUser()
              this.$store.commit('login')
            } else {
              this.$store.commit('logout')
            }
          }
        )
    },
    setUser: function () {
      storageLocal.get(['user_id', 'first_name', 'last_name', 'user_role', 'user_email'])
        .then(
          user  => {
            this.$store.commit('user', {
              id: user[0],
              first_name: user[1],
              last_name: user[2],
              email: user[4],
              role: user[3]
            })
          }
        )
    }
  },
  computed: {
    loading: function () {
      return this.$store.state.loading
    },
    isLoggedIn: function () {
      return this.$store.state.isLoggedIn
    }
  }
}
</script>

<style lang="sass">
@import "assets/sass/base/_defaults"
</style>



// WEBPACK FOOTER //
// src/App.vue